import React, { useState } from "react";
import DrawerFilter from "../../../components/listing/DrawerFilter";

export default function FiltroRubro({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  const [codigo, setCodigo] = useState(initialFilters.codigo || "");
  const [nombre, setNombre] = useState(initialFilters.nombre || "");

 const handleApply = () => {
  const filtrosAplicados = {
    codigo: codigo.trim(),
    nombre: nombre.trim(),
  };
  console.log("✅ [FiltroRubro] handleApply - filtros aplicados:", filtrosAplicados);
  onSubmit(filtrosAplicados);
  onClose();
};

  return (
    <DrawerFilter
      title="Filtros de Rubros"
      onClose={onClose}
      onApply={handleApply}
    >
      <div>
        <label className="form-label-fil">Código:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={codigo}
          onChange={(e) => setCodigo(e.target.value)}
          placeholder="Buscar por código..."
        />
      </div>

      <div className="mt-4">
        <label className="form-label-fil">Nombre:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          placeholder="Buscar por nombre..."
        />
      </div>
    </DrawerFilter>
  );
}